"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[30730],{

/***/ 30730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14869);




var ZoomOut = function(props) {
    var children = props.children, className = props.className, delay = props.delay;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_react_spring_web__WEBPACK_IMPORTED_MODULE_2__/* .useSpring */ .q_)(function() {
        return {
            from: {
                scale: 2,
                opacity: 0
            },
            to: {
                scale: 1,
                opacity: 1
            },
            delay: delay,
            config: {
                mass: 2,
                tension: 80
            }
        };
    }), 2), style = ref[0], api = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_spring_web__WEBPACK_IMPORTED_MODULE_2__/* .animated.div */ .q.div, {
        style: style,
        className: className,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ZoomOut);


/***/ })

}]);